/** Charge identity: `charge.<letter>.<number>.<field>`, the number as printed (leading zeros dropped). */
const CHARGE_KEY_RE = /^charge\.([A-Z])\.([0-9]+)\.([a-z_]+)$/;

/** Sentence case: the first character upper, everything else lower. Dots and underscores become spaces. */
export const sentenceCase = (text: string): string => {
  const spaced = text.replace(/[._]/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase();
  return spaced === '' ? '' : `${spaced.charAt(0).toUpperCase()}${spaced.slice(1)}`;
};

/**
 * Human-readable label for a data key. `charge.A.02.buyer_at` reads "Charge A 2 Buyer at":
 * the letter stays upper case, the number loses its leading zero, and the field is sentence case.
 */
export const humanKeyLabel = (key: string): string => {
  const charge = CHARGE_KEY_RE.exec(key);
  if (charge) {
    const [, letter, number, field] = charge;
    return `Charge ${letter} ${Number(number)} ${sentenceCase(field)}`;
  }
  return sentenceCase(key);
};
